// extracted by mini-css-extract-plugin
export var cardBody = "styles-module--cardBody--3ad2a";
export var cardsWrapper = "styles-module--cardsWrapper--f9eb5";
export var richTextWrapper = "styles-module--richTextWrapper--aa44c";